import { z } from "zod";

export const roleSchema = z.enum([
  "user",
  "support",
  "content_manager",
  "finance",
  "admin",
  "superadmin",
]);
export type Role = z.infer<typeof roleSchema>;

export const adminRoles = ["support", "content_manager", "finance", "admin", "superadmin"] as const;
export type AdminRole = (typeof adminRoles)[number];

export function isAdminRole(role: Role): role is AdminRole {
  return (adminRoles as readonly string[]).includes(role);
}
